'use client';

import React from 'react';
import { Icons } from '@shared/ui';

interface SearchBarButtonProps {
    searchKeyword: string;
    onClick: () => void;
    isOpen: boolean;
    onOpen: () => void;
}

export const SearchBarButton = (props: SearchBarButtonProps) => {
    const { searchKeyword, onClick, isOpen, onOpen } = props;

    function handleOnClick() {
        let isDesktopActive = false;

        if (typeof window !== 'undefined' && window) {
            const searchBarBox = document.querySelector('.search-bar-box');

            if (searchBarBox) {
                const { display } = window.getComputedStyle(searchBarBox);

                isDesktopActive = display === 'block';
            }
        }

        if (!isOpen && !isDesktopActive) {
            onOpen();

            return;
        }

        if (searchKeyword) {
            onClick();
        }
    }

    return (
        <button className="search-bar-button" onClick={handleOnClick}>
            <Icons.csr.MagnifyingGlass
                className="search-bar-icon"
                width="24px"
                height="24px"
                weight="bold"
            />
        </button>
    );
};
